import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import AuthenticationService from '../service/AuthenticationService';
import AuthService from '../security/AuthService';
import { useNavigate } from 'react-router-dom';
import PasswordChecklist from "react-password-checklist"
import FileService from '../service/FileService';
import eventBus from '../common/EventBus';
import AccountService from '../service/AccountService';

const CustomLogin = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useRef(null);


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);
    const [displayForgot, setDisplayForgot] = useState(false);
    const [isSendVerifyToken, setIsSendVerifyToken] = useState(false);

    const [isVerifyToken, setIsVerifyToken] = useState(false);


    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [verifyToken, setVerifyToken] = useState("");
    const [showPassword, setShowPassword] = useState(false);


    const checkButtonStatus = () => {

        if (username && password) {
            return false;
        }

        return true;

    }
    const checkForgotButtonStatus = () => {

        if (username) {
            return false;
        }

        return true;

    }

    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }

    const loadUserInfo = (token) => {
        return new Promise((resolve, reject) => {
            //console.log('setAuthentication', token);
            try {
                //setDisplayLoadingDialog(true);
                AccountService.inquireUserWithToken(token).then(
                    (response) => {
                        console.log("loadUserInfo", response)

                        if (response?.data?.data?.dataList?.length > 0) {
                            console.log("set inquireFollowed", response?.data?.data?.dataList)
                            let _info = response?.data?.data?.dataList[0];

                            AuthService.setHeaderImage(_info.profileHeader);
                            AuthService.setProfileImage(_info.profileImage);


                        }else{
                            AuthService.setHeaderImage();
                            AuthService.setProfileImage();
                        }


                        resolve(response);
                    },
                    (error) => {
                        console.log("loadFile error*", error)

                        //  setDisplayLoadingDialog(false);

                        const _content =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        console.log(_content);

                        if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                            console.log("inquireFollowed logout******")
                            eventBus.dispatch("logout", props);
                        } else {
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                        }
                        reject(error);
                    }
                );
            } catch {
                reject("Unhandled Error")
            }
        });
    }

    const onLogin = () => {
        showLoading();
        //if (captchaCheck) {
        try {
            AuthenticationService.signin(username, password).then(response => {
                console.log("signin", response);

                if (response?.data?.error) {
                    hideLoading();
                    let _content = response?.data?.error?.message ? response?.data?.error?.message : response?.data?.error?.innerExceptionMessage;

                    if (t(_content)) {
                        _content = t(_content);
                    }



                    props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: _content, life: 5000 });


                } else if (response?.status >= 200 && response?.status < 300) {

                    console.log("signin", response);
                    console.log(JSON.stringify(response?.data?.data?.response));
                    const accessToken = response?.data?.data?.response;
                    console.log(accessToken);

                    AuthService.setAuthentication(accessToken).then(response => {
                        console.log("setAuthentication", response);

                        setUsername('');
                        setPassword('');
                        if (props?.setDialogVisible) {
                            props?.setDialogVisible(false);
                        }
                        if (props?.op?.current) {
                            props.op.current.hide();

                        }
                        loadUserInfo(response).then(responseLoad => {
                            // navigate(`/profile/${response.userId}/${response.userType}`)
                            console.log("loadFile responseLoad ", responseLoad)
                            navigate(`/`)
                        })



                    });


                    props.toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: t('global_success'), life: 3000 });

                }
                else if (response?.status === 400) {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                } else if (response?.status === 401) {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                } else if (response?.status === 422) {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                } else {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });

                }
            })
                .catch(err => {
                    hideLoading();

                    if (!err?.response) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    } else if (err.response?.status === 400) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                    } else if (err.response?.status === 401) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                    } else if (err.response?.status === 422) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                    } else {
                    }
                    console.error(err);
                });


        } catch (err) {
            hideLoading();
            if (!err?.response) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            } else if (err.response?.status === 400) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
            } else if (err.response?.status === 401) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
            } else if (err.response?.status === 422) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
            } else {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            }
            console.error(err);
            //	errRef.current.focus();
        }
    }
    const doSendVerifyPassword = () => {
        showLoading();
        //if (captchaCheck) {
        try {
            if (username?.length > 0) {
                AuthenticationService.forgotpassword(username).then(response => {
                    console.log("forgotpassword", response);

                    if (response?.data?.error) {
                        hideLoading();
                        let _content = response?.data?.error?.message ? response?.data?.error?.message : response?.data?.error?.innerExceptionMessage;

                        if (t(_content)) {
                            _content = t(_content);
                        }



                        props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: _content, life: 5000 });


                    } else if (response?.status >= 200 && response?.status < 300) {

                        console.log("doSendVerifyPassword success");
                        setIsSendVerifyToken(true);


                    }
                    else if (response?.status === 400) {
                        hideLoading();
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                    } else if (response?.status === 401) {
                        hideLoading();
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                    } else if (response?.status === 422) {
                        hideLoading();
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                    } else {
                        hideLoading();
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });

                    }
                })
                    .catch(err => {
                        hideLoading();

                        if (!err?.response) {
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
                        } else if (err.response?.status === 400) {
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                        } else if (err.response?.status === 401) {
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                        } else if (err.response?.status === 422) {
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                        } else {
                        }
                        console.error(err);
                    });

            } else {
                props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_login_missing_user_name_or_email"), life: 5000 });

                hideLoading();

            }
        } catch (err) {
            hideLoading();
            if (!err?.response) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            } else if (err.response?.status === 400) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
            } else if (err.response?.status === 401) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
            } else if (err.response?.status === 422) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
            } else {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            }
            console.error(err);
            //	errRef.current.focus();
        }
    }
    const doForgotPassword = () => {
        showLoading();
        //if (captchaCheck) {
        try {
            if (username?.length > 0 && password?.length > 0) {
                if (password == passwordConfirm) {
                    const apiParams = { email: username, password, passwordConfirm, verificationToken: verifyToken };
                    AuthenticationService.forgotPasswordVerify(apiParams).then(response => {
                        console.log("forgotpassword", response);

                        if (response?.data?.error) {
                            hideLoading();
                            let _content = response?.data?.error?.message ? response?.data?.error?.message : response?.data?.error?.innerExceptionMessage;

                            if (t(_content)) {
                                _content = t(_content);
                            }



                            props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: _content, life: 5000 });


                        } else if (response?.status >= 200 && response?.status < 300) {

                            console.log("forgotpassword success");

                            setIsVerifyToken(true);



                        }
                        else if (response?.status === 400) {
                            hideLoading();
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                        } else if (response?.status === 401) {
                            hideLoading();
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                        } else if (response?.status === 422) {
                            hideLoading();
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                        } else {
                            hideLoading();
                            props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });

                        }
                    })
                        .catch(err => {
                            hideLoading();

                            if (!err?.response) {
                                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
                            } else if (err.response?.status === 400) {
                                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                            } else if (err.response?.status === 401) {
                                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                            } else if (err.response?.status === 422) {
                                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                            } else {
                            }
                            console.error(err);
                        });
                } else {
                    props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_notconfirm"), life: 5000 });

                    hideLoading();
                }
            } else {
                props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_login_missingusernamepassword"), life: 5000 });

                hideLoading();

            }
        } catch (err) {
            hideLoading();
            if (!err?.response) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            } else if (err.response?.status === 400) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
            } else if (err.response?.status === 401) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
            } else if (err.response?.status === 422) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
            } else {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            }
            console.error(err);
            //	errRef.current.focus();
        }
    }


    const authInfo = () => {
        return (
            <div className="col-12 md:col-12 flex justify-content-center  p-3" >
                <div className=" w-12  ">

                    <div className="col-12 md:col-12">
                        <div className="grid formgrid">
                            <div className="col-12 md:col-12 mb-3">
                                <InputText id="username" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="off"
                                    className="inputtext_raunded p-inputtext w-12" type="text" placeholder={t('global_text_user_name_or_email')}></InputText>
                            </div>
                            <div className="col-12 md:col-12 ">
                                <InputText type="password" placeholder={t("global_text_password")}
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                    required
                                    className="inputtext_raunded p-inputtext  w-12"
                                />
                            </div>


                        </div>

                    </div>

                </div>
            </div>
        )

    }



    const renderButton = () => {

        return (
            <div className=" flex  pr-3 pb-3 w-12 justify-content-end">
                <Button label={t('global_text_forgotpassword')} className="p-button-rounded  p-button-secondary mr-2 mb-2 " text
                    onClick={() => setDisplayForgot(true)}></Button>

                <Button label={t('global_btn_login')} className="p-button-rounded mr-2 mb-2 pr-3 pl-3"

                    disabled={checkButtonStatus()} onClick={() => onLogin()}></Button>
            </div>
        )
    }
    const renderForgotButton = () => {

        return (
            <div className=" flex  pr-3 pb-3 w-12 justify-content-end">

                <Button label={t('global_btn_login')} className="p-button-rounded mr-2 mb-2 pr-3 pl-3"
                    onClick={() => {
                        setDisplayForgot(false);
                        setIsSendVerifyToken(false);
                    }
                    }></Button>
            </div>
        )
    }
    const renderVerifyButton = () => {

        return (
            <div className=" flex  pr-3 pb-3 w-12 justify-content-end">

                <Button label={t('global_btn_update')} className="p-button-rounded mr-2 mb-2 pr-3 pl-3"
                    onClick={() => {
                        doForgotPassword();
                    }
                    }></Button>
            </div>
        )
    }


    const mailInfo = () => {
        return (
            <div className="col-12 md:col-12 flex justify-content-center  " >
                <div className="w-12  ">

                    <div className="col-12 md:col-12">
                        <div className="grid formgrid">
                            <div className="col-12 md:col-12 mb-3 mt-3">
                                <InputText id="username" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="off"
                                    className="inputtext_raunded p-inputtext w-12" type="text" placeholder={t('global_text_user_name_or_email')}></InputText>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        )

    }

    const verifyInput = () => {
        return (
            <div className="col-12 md:col-12 flex justify-content-center  " >
                <div className=" w-12 m-2  ">

                    <div className="col-12 md:col-12">
                        <div className="grid formgrid">
                            <div className="col-12 md:col-12 mb-3">
                                <InputText type="verifyToken" placeholder={t("forgotpassword_verification_code")}
                                    onChange={(e) => setVerifyToken(e.target.value)}
                                    value={verifyToken}
                                    required
                                    className="inputtext_raunded p-inputtext  w-12"
                                />
                            </div>
                            <div className="col-12 md:col-12 mb-3">
                                <InputText type="password" placeholder={t("global_text_password")}
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                    required
                                    className="inputtext_raunded p-inputtext  w-12"
                                />
                            </div>
                            <div className="col-12 md:col-12 mb-3">
                                <InputText type="password" placeholder={t("global_text_confirmpassword")}
                                    onChange={(e) => setPasswordConfirm(e.target.value)}
                                    value={passwordConfirm}
                                    required
                                    className="inputtext_raunded p-inputtext  w-12"
                                />
                            </div>
                            <div className="col-12 md:col-12 mb-3">
                                <PasswordChecklist
                                    rules={["minLength", "specialChar", "number", "capital", "match"]}
                                    minLength={5}
                                    value={password}
                                    valueAgain={passwordConfirm}
                                    onChange={(isValid) => { }}
                                    messages={{
                                        minLength: t('validation_password_minlength'),
                                        specialChar: t('validation_password_specialchar'),
                                        number: t('validation_password_number'),
                                        capital: t('validation_password_capital'),
                                        match: t('validation_password_match')
                                    }}
                                />
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        )

    }

    const renderButtonForgot = () => {

        return (
            <div className=" flex  pl-3 pr-3 pb-3 w-12 justify-content-between">
                <Button icon="fas fa-arrow-left" className="p-button-rounded  p-button-secondary ml-2  mb-2 "
                    onClick={() => setDisplayForgot(false)}></Button>

                <Button label={t('global_reset_password')} className="p-button-rounded mr-2 mb-2 pr-3 pl-3"

                    disabled={checkForgotButtonStatus()} onClick={() => doSendVerifyPassword()}></Button>
            </div>
        )
    }

    const renderLogin = () => {
        return (
            <>
                {authInfo()}
                {renderButton()}
            </>
        )
    }

    const renderForgot = () => {
        return (
            <>
                {mailInfo()}
                {renderButtonForgot()}
            </>
        )
    }
    const renderVerify = () => {
        return (
            <>
                {verifyInput()}
                {renderVerifyButton()}
            </>
        )
    }

    const renderVerificationSend = () => {
        return (
            <>
                <div className="col-12 md:col-12 flex justify-content-center  " >
                    <div className="register-content w-12  ">

                        <div className="col-12 md:col-12">
                            <div className="grid formgrid">
                                <div className="col-12 md:col-12 mb-3">
                                    {t('forgotpassword_success')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {renderForgotButton()}
            </>
        )
    }

    console.log("displayForgot && isSendVerifyToken && !isVerifyToken", displayForgot, isSendVerifyToken, isVerifyToken)

    return (
        <div style={{
            ...props.containerStyle,
            width: "100%",
            minWidth: 315,


        }}>

            {!displayForgot && renderLogin()}
            {displayForgot && !isSendVerifyToken && renderForgot()}
            {displayForgot && isSendVerifyToken && !isVerifyToken && renderVerify()}
            {displayForgot && isSendVerifyToken && isVerifyToken && renderVerificationSend()
            }
        </div>
    )
}

export default CustomLogin;